export const UPDATE_FEEDBACK_STATE= 'UPDATE_FEEDBACK_STATE';
export const FEEDBACK_LOADING= 'FEEDBACK_LOADING';
export const FEEDBACK_LOADED= 'FEEDBACK_LOADED';
export const FEEDBACK_ERROR= 'FEEDBACK_ERROR';
export const FEEDBACK_CHATLOG_LOADED= 'FEEDBACK_CHATLOG_LOADED';



// WEBPACK FOOTER //
// ./src/data/redux/feedback_details/actiontypes.js